export const sideDrawer = {
  topNavHeight:"120px",
  outerClasses:"rvit-side-nav-drawer"
}